import React, { useState, useRef, useEffect } from 'react'
import { checkForEmptyProperties, getPollingLocationHours } from '@utils'

import { Loader } from '@elements'
import Tabs from '@elements/Tabs'

import LocationMap from './LocationMap'

// import testPollingLocations from './test_polling_locations'

export const PollingLocations = ({ content, headline }) => {
  const [loading, setLoading] = useState(false)
  const [goodQuery, setGoodQuery] = useState()
  const [results, setResults] = useState({})
  const [errors, setErrors] = useState()
  const [userAddress, setUserAddress] = useState('')
  const [selectedLocation, setselectedLocation] = useState()
  const [selectedTab, setSelectedTab] = useState('Early Voting Sites')
  const inputEl = useRef(null)

  const handleSelectedChange = newValue => {
    setselectedLocation(newValue)
  }

  const handleTabChange = newValue => {
    setSelectedTab(newValue)
  }

  useEffect(() => {
    if (userAddress !== '') {
      setLoading(true)
      fetch(
        `https://www.googleapis.com/civicinfo/v2/voterinfo?address=${encodeURIComponent(
          userAddress
        )}&electionId=7000&key=AIzaSyDv109Dy4ALE3_0rVMEeHaT6Fej_oT_75I`
      )
        .then(res => res.json())
        .then(data => {
          // data.earlyVoteSites = undefined
          // if (!data.pollingLocations) {
          //   data.pollingLocations = testPollingLocations
          // }
          setResults(data)
          setGoodQuery(checkForEmptyProperties(data.normalizedInput))
          setLoading(false)
        })
        .catch(e => {
          setErrors(e.message)
          setLoading(false)
        })
    }
  }, [userAddress])

  const handleSubmit = e => {
    e.preventDefault()
    setUserAddress(inputEl.current.value)
  }

  return (
    <section className="py-20 bg-white">
      <div className="container">
        <div className="lg:flex mb-20 lg:mb-30">
          <div className="lg:w-2/3">
            <h2 className="font-sans text-3xl font-bold leading-snug tracking-wider uppercase sm:text-5xl lg:text-4xl xl:text-5xl text-brand-red sm:leading-tight">
              {headline}
            </h2>

            <div dangerouslySetInnerHTML={{ __html: content }} />
          </div>

          <div className="lg:w-1/3">
            <form onSubmit={handleSubmit}>
              <label htmlFor="search">
                <span className="block mb-1 font-sans text-lg font-bold tracking-wide uppercase">
                  Your Address
                </span>
                <input
                  className="block w-full px-4 py-3 font-sans leading-tight text-gray-400 bg-white border border-gray-200 appearance-none focus:outline-none focus:bg-white focus:border-gray-500"
                  ref={inputEl}
                  type="text"
                  id="search"
                  defaultValue=""
                  placeholder="1234 Drive Street, Indianapolis, Indiana"
                />
              </label>
              {goodQuery ? (
                <div className="w-full mt-1 text-sm text-gray-300">
                  <span className="inline-block mr-2 text-xs text-brand-teal">
                    &#9679;
                  </span>
                  Success
                </div>
              ) : goodQuery === false ? (
                <div className="w-full mt-1 text-sm text-gray-300">
                  <span className="inline-block mr-2 text-xs text-brand-yellow">
                    &#9679;
                  </span>
                  For more accurate results, please enter a full address
                </div>
              ) : errors ? (
                <div className="w-full mt-1 text-sm text-gray-300">
                  <span className="inline-block mr-2 text-xs text-brand-red">
                    &#9679;
                  </span>
                  Please enter a full address, including city, state, and zip
                  code
                </div>
              ) : null}

              <button
                type="submit"
                className="block px-6 pt-2 pb-1 mt-8 mb-2 mr-4 font-sans text-xl font-bold text-center text-gray-400 no-underline uppercase transition duration-200 border-4 lg:inline-block lg:mb-0 border-brand-yellow xl:text-3xl hover:bg-brand-yellow"
                href="/"
              >
                Submit
              </button>
            </form>
          </div>
        </div>

        {loading && (
          <div className="w-full flex items-center justify-center">
            <div className="relative py-20 xl:py-40 pr-20">
              <Loader />
            </div>
          </div>
        )}

        {goodQuery && !loading && (
          <div className="">
            <h2 className="mb-10 font-sans text-3xl font-bold leading-snug tracking-wider uppercase sm:text-5xl lg:text-4xl xl:text-5xl sm:leading-tight text-center block w-full">
              Your Polling Location(s)
            </h2>

            <div className="xl:flex">
              <div className="xl:w-2/3 xl:pr-10">
                <Tabs onTabChange={handleTabChange}>
                  <div label="Early Voting Sites">
                    {results.earlyVoteSites ? (
                      <div className="hidden md:block">
                        <table className="table-auto w-full xl:w-auto mb-10">
                          <tbody>
                            {results.earlyVoteSites.map(location => {
                              return (
                                <LocationRow
                                  key={location.address.locationName}
                                  location={location}
                                  onClick={location =>
                                    setselectedLocation(location)
                                  }
                                />
                              )
                            })}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <p>
                        Sorry, No Early Voting Sites availible for this address.
                        Please check back at a later time.
                      </p>
                    )}
                  </div>
                  <div label="Polling Locations">
                    {results.pollingLocations ? (
                      <div className="hidden md:block">
                        <table className="table-auto w-full xl:w-auto">
                          <tbody>
                            {results.pollingLocations.map(location => {
                              return (
                                <LocationRow
                                  key={location.address.locationName}
                                  location={location}
                                  onClick={location =>
                                    setselectedLocation(location)
                                  }
                                />
                              )
                            })}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <p>
                        Sorry, No Polling Locations availible for this address.
                        Please check back at a later time.
                      </p>
                    )}
                  </div>
                </Tabs>
              </div>
              <div className="xl:w-1/3">
                <LocationMap
                  locations={
                    selectedTab === 'Early Voting Sites'
                      ? results.earlyVoteSites
                      : results.pollingLocations
                  }
                  selected={selectedLocation}
                  onSelectedChange={handleSelectedChange}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  )
}

function LocationRow({ location, onClick }) {
  const handlClick = () => {
    onClick(location)
  }

  return (
    <tr
      onClick={handlClick}
      className="cursor-pointer border-b-2 border-gray-200"
    >
      <td className="pr-4 py-2 text-gray-300 font-bold">
        {location.address.locationName}
      </td>
      <td className="px-4 py-2">
        {location.address.line1} {location.address.city},{' '}
        {location.address.state} {location.address.zip}
      </td>
      <td className="pl-4 py-2 font-bold" style={{ whiteSpace: 'nowrap' }}>
        {getPollingLocationHours(location.pollingHours)}
      </td>
    </tr>
  )
}
